import './index.scss';
import { __ } from '@wordpress/i18n';
import { overflowlist } from './overflowlist.js'

import classnames from 'classnames';
import { addFilter } from '@wordpress/hooks';
import { InspectorAdvancedControls } from '@wordpress/block-editor';
import { ToggleControl, TextareaControl, SelectControl, RangeControl } from '@wordpress/components';


const allowedBlocks = ['core/group'];

const acustomDefaults = {
	customcss: '',
	customcssId: '',
	overflow: '',
	groupWidth: 3,
	groupGap: 2,
	hiddenOnMobile: false,
	hiddenOnTablet: false,
	hiddenOnDesktop: false,			
};


const addAttributes = (settings, name) => {

	if (!allowedBlocks.includes(name)) return settings;

	if (typeof settings.attributes !== 'undefined') {
		if( typeof settings.attributes !== 'undefined' ) {		
			settings.attributes = {
				...settings.attributes,
				
				acustom: {
					type: 'object',
					default: acustomDefaults
				}
			}
		}
	}

	return settings;
}


const addInspectorControl = (BlockEdit) => (props) => {
	if (!allowedBlocks.includes(props.name)) {
		return <BlockEdit {...props} />;
	}

	const { attributes, setAttributes, isSelected } = props;
	const { acustom = {} } = attributes;

	const orgDefaults = {
		...acustomDefaults,
		...(attributes.acustom || {}),
	};

	const { 
		customcss,
		customcssId,
		overflow,
		groupWidth,
		groupGap,
		hiddenOnMobile,
		hiddenOnTablet,
		hiddenOnDesktop
	} = orgDefaults;


	const updateObject = (obj, key, newVal) => ({	...obj,	[key]: newVal });
	const updateArray = (list, index, newVal) => {
		const listsCopy = [...list];
		listsCopy[index] = newVal;
		return listsCopy;
	}


	return (
		<>
			<BlockEdit {...props} />

			
				<InspectorAdvancedControls>
				
					<TextareaControl
						label={__('Custom CSS', 'aver')}
						value={customcss}
						onChange={(newVal) => {			
							if (newVal != ''){				
								setAttributes({	acustom: {...acustom, customcss: newVal, customcssId: props.clientId.substring(0, 10) }	}); 
							} else {
								setAttributes({	acustom: {...acustom, customcss: '', customcssId: '' }	}); 
							}
						}}
						help={__('Add Custom CSS for this block-' + customcssId, 'aver')}
					/>

					<ToggleControl
						label={__('Mobile Devices Visibility')}
						checked={hiddenOnMobile}
						onChange={(val) =>
							setAttributes({
								acustom: {...acustom, hiddenOnMobile: val }
							})
						}
						help={
							hiddenOnMobile
								? __('Hidden on <782px.', 'aver')
								: __('Showing on mobile devices.', 'aver')
						}
					/>

					<ToggleControl
						label={__('Tablet Devices Visibility')}
						checked={hiddenOnTablet}
						onChange={(val) =>
							setAttributes({
								acustom: {...acustom, hiddenOnTablet: val }
							})
						}
						help={
							hiddenOnTablet
								? __('Hidden on 782px–1024px.', 'aver')
								: __('Showing on tablet devices.', 'aver')
						}
					/>

					<ToggleControl
						label={__('Desktop Devices Visibility')}
						checked={hiddenOnDesktop}
						onChange={(val) =>
							setAttributes({
								acustom: {...acustom, 'hiddenOnDesktop': val }
							})
						}
						help={
							hiddenOnDesktop
								? __('Hidden on >1024px.', 'aver')
								: __('Showing on desktop devices.', 'aver')
						}
					/>

					<SelectControl
						label={ __( 'Overflow', 'aver' ) }
						options={ overflowlist }
						value={ overflow }
						onChange={ ( newval ) => { setAttributes( { acustom: {...acustom, overflow:newval} } ) }	}
					/>	
		
					{ overflow == 'scroll-x' && <>			
				
						<RangeControl
							label={ __( 'width*50 in px', 'aver' ) }
							value={ groupWidth }
							min={ 0 }
							max={ 10 }
							step={ 1 }
							onChange={ ( newval )=> { setAttributes( { acustom: {...acustom, groupWidth:newval} } )	}	}
						/>

						<RangeControl
							label={ __( 'gaps*10 in px', 'aver' ) }
							value={ groupGap }
							min={ 0 }
							max={ 10 }
							step={ 1 }
							onChange={ ( newval )=> { setAttributes( { acustom: {...acustom, groupGap:newval} } )	}	}
						/>					
					
					</>
					}
					
				</InspectorAdvancedControls>
			
		</>
	);
};



const applyExtraClassEditor = (BlockListBlock) => (props) => {

	if (!allowedBlocks.includes(props.name)) {
		return <BlockListBlock {...props} />;
	}

	const { attributes, wrapperProps, className } = props;
	const { acustom = {} } = attributes;
	const orgDefaults = {
		...acustomDefaults,
		...(attributes.acustom || {}),
	};

	const { 
		customcss,
		customcssId,
		overflow,
		groupWidth,
		groupGap,
		hiddenOnMobile,
		hiddenOnTablet,
		hiddenOnDesktop
	} = orgDefaults;


	const cssstyle = { 		
		...wrapperProps?.style,		
	}

	const classes = classnames(
		className, 
		{
			'a-m-hidden': hiddenOnMobile,
			'a-t-hidden': hiddenOnTablet,
			'a-d-hidden': hiddenOnDesktop,
			[`block-${customcssId}`]: customcss,
			[`a-overflow-${overflow}`]: overflow,
			[`a-width-c${groupWidth} a-gap-c${groupGap}`]: ( overflow == 'scroll-x' && groupWidth != 0 ),				
		}
	)

	return (
	<>
		<BlockListBlock 
			{ ...props } 
			wrapperProps={ { style: cssstyle } } 
			className={ classes } 
		/>
		{ customcss && (	<style>{`.block-${customcssId}{ ${customcss} }`}</style> ) }
	</>
	)

}

const applyExtraClassSave = ( extraProps, blockType, attributes ) => {    

	if ( ! allowedBlocks.includes( blockType?.name ) ) {
		return extraProps;
	}

	const { acustom } = attributes;
	if (!acustom || acustom == {}) return extraProps;

	const isDifferentFromDefault = JSON.stringify({ ...acustom }) !== JSON.stringify({ ...acustomDefaults });	
	if (!isDifferentFromDefault) return extraProps;

	const updatedata = {}; 

	for (const key in acustom) {
		const val = acustom[key];
		const def = acustomDefaults[key];

		if (val === undefined) continue;

		if (JSON.stringify(val) !== JSON.stringify(def) && val !== '') {
			updatedata[key] = val;			
		}
	}

	attributes.acustom = updatedata;
	return extraProps;
}


addFilter(
	'blocks.registerBlockType', 
	'aver/acustom-attributes', 
	addAttributes
);

addFilter(
	'editor.BlockEdit', 
	'aver/acustom-advanced-control', 
	addInspectorControl
);

addFilter(
	'editor.BlockListBlock', 
	'aver/acustom-editor-class', 
	applyExtraClassEditor
);

addFilter( 'blocks.getSaveContent.extraProps',  'aver/acustom-save-class',  applyExtraClassSave );